import sanitizeHtml from 'sanitize-html';

/**
 * Производит санитизацию комментария к посту
 */
export const sanitizePostComment = (html: string) =>
  sanitizeHtml(html, {
    allowedTags: ['br'],
  });
